import { baseSiteEndPoint, buildHeaders, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiSplitPlans = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/plans/plans/split`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};


export const apiDetailsSplitPlans = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/plans/plans/split/${id}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiUpdateSplitPlan = async (id, jsonData) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/plans/plans/split/${id}/`, {
      method: "PATCH",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const apiCreateSplitPlan = async (jsonData) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/plans/plans/split/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });
    return response;
  } catch (error) {
    throw error;
  }
};
